"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': 'Tutorial statistics',
    'tutorial.statistics.details': 'Tutorial participants and progress',
    'tutorial.statistics.subtitle': 'Select a tutorial to view participant progress.',
    'tutorial.statistics.tutorial': 'Tutorial',
    'tutorial.statistics.category': 'Category',
    'tutorial.statistics.actions': 'Actions',
    'tutorial.statistics.viewParticipants': 'View participants',
    'tutorial.statistics.search': 'Search',
    'tutorial.statistics.retry': 'Try again',
    'tutorial.statistics.refresh': 'Refresh',
    'tutorial.statistics.back': 'Back to tutorials',
    'tutorial.statistics.pagination': 'Tutorial pages',
    'tutorial.statistics.previous': 'Previous',
    'tutorial.statistics.next': 'Next',
    'tutorial.statistics.participants': 'Participants',
    'tutorial.statistics.participant': 'Participant',
    'tutorial.statistics.identity': 'Participant type',
    'tutorial.statistics.registered': 'Registered user',
    'tutorial.statistics.guest': 'Guest',
    'tutorial.statistics.currentStep': 'Last saved step',
    'tutorial.statistics.currentSection': 'Last saved section',
    'tutorial.statistics.tasks': 'Completed tasks',
    'tutorial.statistics.progress': 'Progress',
    'tutorial.statistics.progressExplanation': 'Progress is the percentage of tutorial tasks completed by each participant. Saved position does not indicate completion.',
    'tutorial.statistics.notStarted': 'No saved position',
    'tutorial.statistics.noTasks': 'No tasks',
    'tutorial.statistics.emptyTutorials': 'No tutorials found.',
    'tutorial.statistics.emptyParticipants': 'No participants in this tutorial yet.',
    'tutorial.statistics.loadFailed': 'Failed to load tutorial statistics.',
    'tutorial.statistics.time_data': 'Participant tutorial time data',
    'tutorial.statistics.viewTimeData': 'View time data',
    'tutorial.statistics.time': 'Time in section',
};
